export default {
  init() {
    $('.event-slider').slick({
      prevArrow: $('.event-slider-prev-button'),
      nextArrow: $('.event-slider-next-button'),
    });

  }
};
